export default (state = {}, action) => {
  switch (action.type) {
    case 'DATA_FOR_SELECT_ACCOUNT':
      return {
        ...state,
        dataForSelectAccount: action.data
      }
    case 'DATA_FOR_TAGUEO':
      return {
        ...state,
        dataTagueo: action.data
      }
    case 'DATA_FOR_ADDRESS_FORM':
      return {
        ...state,
        dataForAddressForm: action.data
      }
    case 'DATA_FOR_CLIENTE':
      return {
        ...state,
        dataCliente: action.data
      }
    case 'DATA_ACCOUNT_TYPE':
      return {
        ...state,
        dataTipoCuenta: action.data
      }
    case 'DATA_PHYSICAL':
      return {
        ...state,
        dataEcFisico: action.data
      }
    case 'DATA_FOR_OCCUPANCY':
      return {
        ...state,
        dataForOccupancy: action.data
      }
    case 'DATA_FOR_TERMS':
      return {
        ...state,
        dataForTerms: action.data
      }
    case 'DATA_FOR_CAMPANA':
      return {
        ...state,
        dataForCampana: action.data
      }
    case 'DATA_AWARD':
      return {
        ...state,
        dataAward: action.data
      }
    case 'ERROR':
      return {
        ...state,
        error: action.data
      }
    case 'DATANAME':
      return {
        ...state,
        dataName: action.data
      }
    case 'MOSTRAR_PEP':
      return {
        ...state,
        mostrarPep: action.data
      }
    case 'MOSTRAR_FATCA':
      return {
        ...state,
        mostrarFatca: action.data
      }
    case 'NOMBRE_USUARIO':
      return {
        ...state,
        nombreUsuario: action.data
      }
    case 'MOSTRAR_DIRECCION':
      return {
        ...state,
        mostrarDireccion: action.data
      }
    case 'VALORES_DIRECCION':
      return {
        ...state,
        valoresDireccion: action.data
      }
    case 'OPERATION_NUMBER':
      return {
        ...state,
        operationNumber: action.data
      }
    case 'MONEDA_SELECCIONADA':
      return {
        ...state,
        monedaSeleccionada: action.data
      }
    case 'PRODUCTS_ATRIBUTES':
      return {
        ...state,
        productAtributes: action.data
      }
    case 'DATA_EMAIL':
      return {
        ...state,
        correo: action.data
      };
    case 'CUENTA_DIGITAL_ACTIVE':
      return {
        ...state,
        isCuentaDigitalActive: action.data
      };
    case 'CUENTA_CELULAR':
      return {
        ...state,
        cuentaCelular: action.data
      };
    case 'DATOS_BANNER':
      return {
        ...state,
        datosBanner: action.data
      };
    case 'FOOTER_DATA':
      return {
        ...state,
        footerData: action.data
      };
    default:
      return state;
  }
}